import { render, staticRenderFns } from "./CompetitionGuide.vue?vue&type=template&id=1874dd0a&scoped=true"
import script from "./CompetitionGuide.vue?vue&type=script&lang=js"
export * from "./CompetitionGuide.vue?vue&type=script&lang=js"
import style0 from "./CompetitionGuide.vue?vue&type=style&index=0&id=1874dd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874dd0a",
  null
  
)

export default component.exports